// extracted by mini-css-extract-plugin
module.exports = {"textArea":"pgheh1pV"};